/**
 * Tags for compose-created recipes.
 * Keep `size:` for extractRecipeSizeLabel / series tooling; also emit bare
 * size + style so list search matches common ad-hoc tags operators already use.
 */

export function composeSizeTags(sizeLabel: string | null | undefined): string[] {
  const size = (sizeLabel ?? "").trim();
  if (!size) return [];
  return [`size:${size}`, size];
}

/** Bare style token (lowercase) — not `style:…`, which operators don't search. */
export function composeStyleTags(styleKey: string | null | undefined): string[] {
  const style = (styleKey ?? "").trim().toLowerCase();
  return style ? [style] : [];
}

export function composeProductTags(
  sizeLabel: string | null | undefined,
  styleKey: string | null | undefined,
): string[] {
  return [...composeSizeTags(sizeLabel), ...composeStyleTags(styleKey)];
}

export function composeComponentTags(opts: {
  sizeLabel: string | null | undefined;
  styleKey: string | null | undefined;
  slotKey: string;
  variantKey: string | null | undefined;
  fillSlug?: string | null;
}): string[] {
  const tags = [
    ...composeSizeTags(opts.sizeLabel),
    `slot:${opts.slotKey}`,
    ...(opts.variantKey ? [`variant:${opts.variantKey}`] : []),
    ...composeStyleTags(opts.styleKey),
  ];
  if (opts.fillSlug) tags.push(`fill:${opts.fillSlug}`);
  return tags;
}
